<template>
  <tr-loading
    v-if="isLoading"
    classes="center-h-and-v width-100 vertical-offset5"
  />
  <div
    v-if="!isLoading"
    class="limits-container row"
  >
    <limits-detail
      v-for="(paymentMethodLimits, index) in limits"
      :key="index"
      :limits="paymentMethodLimits"
    />
  </div>
</template>

<script>
import LimitsDetail from '@/apps/admin/limits/components/container/LimitsDetail.vue';
import limitsResource from '@/apps/admin/limits/resources/limits';
import { paymentType } from '@transfeeradev/api-enums';
import limitTypes from '@transfeeradev/api-enums/limitType';
import { useErrorHandler } from '@/commons/composables/useErrorHandler';
const { handleError } = useErrorHandler();

export default {
  name: 'limits-container',
  components: {
    LimitsDetail
  },
  data() {
    return {
      limits: {},
      isLoading: true
    };
  },
  created() {
    this.fetchLimits();
  },
  methods: {
    async fetchLimits() {
      try {
        const response = await limitsResource.getAll();
        this.limits = this.formatLimits(response);
        this.isLoading = false;
      } catch (e) {
        handleError(e, 'Ocorreu um erro ao buscar os limites.');
      }
      this.isLoading = false;
    },
    formatLimits(apiResponse) {
      return [
        {
          paymentMethod: paymentType.PIX,
          limits: [
            { type: limitTypes.TRANSACTION, value: apiResponse.TRANSACTION.PIX },
            { type: limitTypes.DAILY, value: apiResponse.DAILY.PIX },
            { type: limitTypes.NIGHTLY, value: apiResponse.NIGHTLY.PIX },
            { type: limitTypes.WEEKEND, value: apiResponse.WEEKEND.PIX }
          ]
        },
        {
          paymentMethod: paymentType.TEV,
          limits: [
            { type: limitTypes.TRANSACTION, value: apiResponse.TRANSACTION.TEV },
            { type: limitTypes.DAILY, value: apiResponse.DAILY.TEV },
            { type: limitTypes.NIGHTLY, value: apiResponse.NIGHTLY.TEV },
            { type: limitTypes.WEEKEND, value: apiResponse.WEEKEND.TEV }
          ]
        },
        {
          paymentMethod: paymentType.TED,
          limits: [
            { type: limitTypes.TRANSACTION, value: apiResponse.TRANSACTION.TED },
            { type: limitTypes.DAILY, value: apiResponse.DAILY.TED }
          ]
        },
        {
          paymentMethod: paymentType.BILLET,
          limits: [
            { type: limitTypes.TRANSACTION, value: apiResponse.TRANSACTION.BILLET },
            { type: limitTypes.DAILY, value: apiResponse.DAILY.BILLET }
          ]
        }
      ];
    }
  }
};
</script>

<style>
.limits-container {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
}
</style>
